import React from "react";
import HighestProfit from "./HighestProfit";
import ViewAllMasterFooter from "./ViewAllMasterFooter";
import TraderSlider from "./TraderSlider";
import { CommonContainer } from "@/styles/Qstyle";

const TopTraderMaster = ({ setTabs }: any) => {
  return (
    <CommonContainer
      style={{
        maxWidth: 1200,
      }}
    >
      <TraderSlider />
      <HighestProfit />
      <TraderSlider />
      <HighestProfit />
      <ViewAllMasterFooter setTabs={setTabs} />
    </CommonContainer>
  );
};

export default TopTraderMaster;
